// extracted by mini-css-extract-plugin
module.exports = {"container":"Tag-module--container--2MCy6"};